'use strict';

function simpleCapitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

module.exports = simpleCapitalize;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/simpleCapitalize.js
// module id = 112
// module chunks = 0